const alphalinkMobileProduct = {
  index: {
  },
  tab: {
    main: "Référence Alphalink",
  },
  new: {
    title: "Nouveau produit mobile alphalink"
  },
  search: {
    number: "Nom",
  }
};

export default alphalinkMobileProduct;
